// extracted by mini-css-extract-plugin
export var productImage = "_redotech-redo-customer-portal-app-src-create-return-components-submit-warranty-registration-productImage";